import React from 'react';
import Css from './ProprBlockMiniMoby.module.css';


function ProprBlockMini(props) {
  

  var o = props.producer;
  var rez=[];
  for (var key in o) {
    rez.push(o[key]);
  }
  
  return (
    <div className={Css.producer}>

{
    rez
    .map((u, i) => 
    <span key={i} >
        {u+" / "}
    </span>
    )
    }
      <span> {props.country}</span>
    </div>
  );
}

export default ProprBlockMini;